import { useTranslation } from 'react-i18next';
import useConfigurationStore from '../store/configurationStore';
import StepNavigation from './StepNavigation';
import StepContent from './StepContent';
import SummaryStep from './SummaryStep';
import PriceSidebar from './PriceSidebar';
import DependencyNotice from './DependencyNotice';
import ProjectInfoStep from './ProjectInfoStep';

export default function Wizard() {
    const { t } = useTranslation();
    const { categories, currentStep, nextStep, prevStep } = useConfigurationStore();

    // Step 0 = Project Info, steps 1..N = categories, last step = summary.
    const isProjectInfo = currentStep === 0;
    const categoryIndex = currentStep - 1;
    const isSummary = currentStep > categories.length;
    const currentCategory = categories[categoryIndex];

    return (
        <div className="ast-wizard">
            <StepNavigation />

            <DependencyNotice />

            <div className="ast-wizard__body">
                <div className="ast-wizard__main">
                    {isProjectInfo ? (
                        <ProjectInfoStep />
                    ) : isSummary ? (
                        <SummaryStep />
                    ) : currentCategory ? (
                        <>
                            <div className="ast-wizard__step-header">
                                <h2>{currentCategory.name}</h2>
                                {currentCategory.description && (
                                    <p className="ast-wizard__step-desc">
                                        {currentCategory.description}
                                    </p>
                                )}
                            </div>
                            <StepContent categoryId={currentCategory.id} />
                        </>
                    ) : null}

                    <div className="ast-wizard__nav-buttons">
                        <button
                            className="ast-btn ast-btn--secondary"
                            onClick={prevStep}
                            disabled={currentStep === 0}
                        >
                            {t('wizard.previous')}
                        </button>
                        {!isSummary && (
                            <button
                                className="ast-btn ast-btn--primary"
                                onClick={nextStep}
                            >
                                {currentStep === categories.length
                                    ? t('wizard.summary')
                                    : t('wizard.next')}
                            </button>
                        )}
                    </div>
                </div>

                <PriceSidebar />
            </div>
        </div>
    );
}
